import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

interface AuthGuardProps {
  children: React.ReactNode;
  redirectTo?: string;
}

/**
 * AuthGuard ensures that only authenticated users can access the protected routes
 * Redirects unauthenticated users to the signin page
 */
export default function AuthGuard({ 
  children, 
  redirectTo = '/signin' 
}: AuthGuardProps) {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Debug logging
  console.log('AuthGuard Debug:', {
    loading,
    user: !!user,
    userEmail: user?.email,
    pathname: location.pathname,
  });

  // If user is not authenticated, redirect to signin
  if (!user) {
    return <Navigate to={redirectTo} replace />;
  }

  // User is authenticated, show the protected content
  return <>{children}</>;
}
